import { motion } from 'framer-motion';
import { useDarkMode } from '../../Services/Context/DarkModeContext';
import './AmbientBackground.css';

const ORB_POSITIONS = [
  { left: '8%', top: '10%', duration: 12, delay: 0 },
  { left: '70%', top: '5%', duration: 15, delay: 2 },
  { left: '20%', top: '60%', duration: 18, delay: 4 },
  { left: '80%', top: '55%', duration: 13, delay: 1 },
  { left: '50%', top: '30%', duration: 20, delay: 6 },
  { left: '38%', top: '80%', duration: 16, delay: 3 },
];

const AmbientBackground = () => {
  const { dark } = useDarkMode();

  return (
    <div className={`AmbientBackground ${dark ? 'AmbientBackground--dark' : ''}`}>
      {ORB_POSITIONS.map((orb, i) => (
        <motion.div
          key={i}
          className="AmbientBackground-orb"
          animate={{
            x: [0, 90, -70, 50, -40, 0],
            y: [0, -80, 60, -100, 40, 0],
            scale: [1, 1.35, 0.75, 1.2, 0.85, 1],
          }}
          transition={{
            duration: orb.duration,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: orb.delay,
          }}
          style={{ left: orb.left, top: orb.top }}
        />
      ))}
    </div>
  );
};

export default AmbientBackground;
